import Vue from 'vue'

const abortControllerUpdate = new AbortController()

export default {
  namespaced: true,
  state: {
    currentInvoice: null,
  },
  actions: {
    // Получение счета на оплату со ссылкой
    // amount – обязательный параметр, сумма оплаты.
    // finance_id – передается при оплате финанса
    // order_ids_to_activate – передается при активации заказа с "оплатой онлайн"
    // order_id_to_update – передается при установке статуса заказа "получено"
    async getPaykeeperInvoice({ commit }, params) {
      const result = await Vue.$http.post('/finance/paykeeper_invoice/', params)
      commit('SET_CURRENT_INVOICE', result)
    },
    // Обновление информации о состоянии текущего счета в стейте
    async updateCurrentInvoice({ state, commit }) {
      abortControllerUpdate.abort()

      const result = await Vue.$http.put('/finance/paykeeper_invoice/', {
        invoice_id: state.currentInvoice.invoice_id,
        signal: abortControllerUpdate.signal,
      })

      commit('SET_CURRENT_INVOICE', {
        ...state.currentInvoice,
        ...result,
      })
    },
    setCurrentInvoice: ({ commit }, invoiceData) => {
      commit('SET_CURRENT_INVOICE', invoiceData)
    },
  },
  mutations: {
    SET_CURRENT_INVOICE: (state, payload) => (state.currentInvoice = payload),
  },
}
